/**
 * Klasse CHAT_SCROLL_FOLLOW — Auto-Follow während ARKO-Stream nur am unteren Rand.
 *
 * Polar:
 * VERBOTEN: scrollIntoView / scrollTop=scrollHeight bei jedem Token, obwohl der User oben liest.
 * ERLAUBT: Follow während Stream, wenn Viewport am unteren Rand (80–120px);
 *          nach Send / neuer User-Bubble einmal nach unten;
 *          manuell wieder nach unten = Follow an.
 *
 * Dist-Fingerprint: PORTAL_CHAT_SCROLL_FOLLOW_MARKER (Live-Chunk).
 */

export const PORTAL_CHAT_SCROLL_FOLLOW_MARKER = 'portal-chat-scroll:stick-to-bottom-v1';

/** Mitte des erlaubten Fensters 80–120px. */
export const CHAT_SCROLL_FOLLOW_THRESHOLD_PX = 100;

export type ChatScrollBox = {
  scrollHeight: number;
  scrollTop: number;
  clientHeight: number;
};

export function distanceFromBottomPx(box: ChatScrollBox): number {
  return box.scrollHeight - box.scrollTop - box.clientHeight;
}

export function isNearChatBottom(
  box: ChatScrollBox,
  thresholdPx: number = CHAT_SCROLL_FOLLOW_THRESHOLD_PX,
): boolean {
  return distanceFromBottomPx(box) <= thresholdPx;
}

/** User-Scroll: Follow nur wenn am unteren Rand. */
export function followAfterUserScroll(
  box: ChatScrollBox,
  thresholdPx: number = CHAT_SCROLL_FOLLOW_THRESHOLD_PX,
): boolean {
  return isNearChatBottom(box, thresholdPx);
}

/**
 * Stream-/Token-Update: nur scrollen wenn Follow aktiv.
 * VERBOTEN: immer scrollen.
 */
export function shouldApplyStreamFollow(follow: boolean): boolean {
  return follow === true;
}

/** Nach Send / neue User-Bubble: Follow wieder an. */
export function followAfterSend(): boolean {
  return true;
}

/**
 * Geste nach oben löst Follow sofort, bevor ein späterer Frame scrollTop setzt.
 * Rad nach unten oder Scrollbar am unteren Rand hängt Follow wieder an (onScroll).
 */
export function shouldDetachFollowForWheel(deltaY: number): boolean {
  return deltaY < 0;
}

export function shouldDetachFollowForKey(key: string): boolean {
  return key === 'PageUp' || key === 'ArrowUp' || key === 'Home';
}

/** Letzte Nachricht ist eine neue User-Bubble → Follow an (einmal nach unten). */
export function followAfterNewUserBubble(
  lastRole: string | undefined,
  lastId: string | undefined,
  alreadyPinnedId: string | null,
): { follow: true; pinnedId: string } | null {
  if (lastRole !== 'user' || !lastId || lastId === alreadyPinnedId) return null;
  return { follow: true, pinnedId: lastId };
}
